/*
 * @Author: Teemo Ding
 * @Date: 2021-07-26 13:21:34
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-13 10:52:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/hooks/useMethodsList.ts
 */
import { useEffect } from 'react';
import _ from 'lodash';

const useMethodsList = (fn, paymentGateway = []) => {
  //重组降维
  useEffect(() => {
    const methodsListData = [].concat(
      ...paymentGateway.map((item) => {
        const {
          paymentGatewayName,
          gatewayProviderName,
          uuid: gatewayProviderUuid,
        } = item;
        const data = item.salesChannelPaymentMethods.filter((i) => i.selected);
        const dataMap = data.map((list) => ({
          ...list,
          paymentGatewayName,
          gatewayProviderName,
          gatewayProviderUuid,
        }));
        return dataMap;
      }),
    );
    methodsListData.sort((a, b) => a.displayOrder - b.displayOrder);
    fn(methodsListData);
  }, [paymentGateway]);
};

const useCurrencyEffect = (setMethodsList, methodsList, currencyConversion) => {
  useEffect(() => {
    const methodsListCopy = _.cloneDeep(methodsList);
    currencyConversion.forEach((value) => {
      methodsListCopy.forEach((item) => {
        const itemCopy = item['chargeableCurrencyList'].filter(
          (o) => o.currencyCode == (value || {}).code,
        );
        if (itemCopy.length == 0) {
          item['chargeableCurrencyList'].push({
            currencyCode: (value || {}).code,
            primaryCurrency: false,
            enabled: false,
          });
        }
      });
    });
    setMethodsList(methodsListCopy);
  }, [currencyConversion]);
};

const useEnableThird = (
  setCurrencyConversion,
  setMethodsList,
  methodsList,
  primaryCurrency,
  enable,
) => {
  useEffect(() => {
    const methodsListCopy = _.cloneDeep(methodsList);
    if (enable) {
      methodsListCopy.forEach((method) => {
        const itemCopy = method['chargeableCurrencyList'].filter(
          (o) => o.currencyCode == primaryCurrency,
        );
        if (itemCopy.length == 0) {
          method['chargeableCurrencyList'] = [
            {
              currencyCode: primaryCurrency,
              primaryCurrency: true,
              enabled: false,
            },
          ];
        }
      });
    } else {
      setCurrencyConversion([]);
      methodsListCopy['chargeableCurrencyList'] = [];
    }
    setMethodsList(methodsListCopy);
  }, [enable]);
};
export { useMethodsList, useCurrencyEffect, useEnableThird };
